import React from 'react'
import { Tabs, Tab } from 'common/views/atoms/Tabs/Tabs'

import { Router, Route, IndexRoute } from 'react-router'
import { browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import { loadReset } from 'common/redux/root'

import App from 'manager/views/App'
import Dashboard from 'manager/views/Dashboard'
import Home from 'manager/views/Home'
import Referral from 'manager/views/Referral'
import ReferralCompanyDetails from 'manager/views/ReferralCompanyDetails'
import ReferralOptOutDetails from 'manager/views/ReferralOptOutDetails'
import Login from 'manager/views/Login'
import ResetPassword from 'manager/views/ResetPassword'
import ChangePassword from 'manager/views/ChangePassword'
import Onboard from 'manager/views/Onboard'
import OnboardStart from 'manager/views/OnboardStart'
import OnboardPrice from 'manager/views/OnboardPrice'
import OnboardClient from 'manager/views/OnboardClient'
import OnboardLocation from 'manager/views/OnboardLocation'
import OnboardFinish from 'manager/views/OnboardFinish'
import Settings from 'manager/views/Settings'
import SettingsHome from 'manager/views/SettingsHome'
import SettingsAvatar from 'manager/views/SettingsAvatar'
import SettingsPrice from 'manager/views/SettingsPrice'
import SettingsClient from 'manager/views/SettingsClient'
import SettingsProperty from 'manager/views/SettingsProperty'
import SettingsLocation from 'manager/views/SettingsLocation'
import SettingsNotification from 'manager/views/SettingsNotification'
import SettingsSnooze from 'manager/views/SettingsSnooze'
import SettingsDoNotDisturb from 'manager/views/SettingsDoNotDisturb'
import SettingsFilterZip from 'manager/views/SettingsFilterZip'
import SettingsBulkFilterZip from 'manager/views/SettingsBulkFilterZip'
import CreateAccount from 'manager/views/CreateAccount'
import NotFound from 'common/views/atoms/NotFound/NotFound'
import ThankYou from 'common/views/atoms/ThankYou/ThankYou'
import TermsAndConditions from 'onboard/views/components/Verify/TermsAndConditions'
import ClientRewardsTermsExpired from 'manager/views/components/ClientRewards/ClientRewardsTermsExpired'
import Training from 'manager/views/components/Training/Training'
import TrainingHome from 'manager/views/components/Training/TrainingHome'
import TrainingTheme from 'manager/views/components/Training/TrainingTheme'
import TitleAndEscrowDetails from "manager/views/TitleAndEscrowDetails";

export default (store) => {
    const history = syncHistoryWithStore(browserHistory, store)

    function isAuthenticated() {
      return !!store.getState().auth.user && 0 != Object.keys(store.getState().auth.user).length
    }

    function requireAuth(nextState, replace) {
      if (!isAuthenticated())
          replace({
            pathname: '/login',
            query: { redirect: nextState.location.pathname }
          })
    }

    function skipLogin(nextState, replaceState) {
      if (isAuthenticated())
          replaceState({ pathname: '/'})
    }

    return (
      <Router onUpdate={() => window.scrollTo(0, 0)} history={history}>
        <Route path="/" component={App}>
          <Route onEnter={requireAuth} component={Dashboard}>
            <IndexRoute component={Home}/>
            <Route path="referral/:hash">
              <IndexRoute component={Referral}/>
              <Route path="loan_details" component={ReferralCompanyDetails} />
              <Route path="other_loan_details" component={ReferralOptOutDetails} />
              <Route path="settlement_details" component={ReferralCompanyDetails} />
              <Route path="title_and_escrow_details" component={TitleAndEscrowDetails} />
              <Route path="other_settlement_details" component={ReferralOptOutDetails} />
            </Route>
            <Route path="onboard" component={Onboard}>
              <IndexRoute component={OnboardStart}/>
              <Route path="price" component={OnboardPrice}/>
              <Route path="client" component={OnboardClient}/>
              <Route path="location" component={OnboardLocation}/>
              <Route path="finish" component={OnboardFinish}/>
            </Route>
            <Route path="settings" component={Settings}>
              <IndexRoute component={SettingsHome}/>
              <Route path="avatar" component={SettingsAvatar}/>
              <Route path="price" component={SettingsPrice}/>
              <Route path="client" component={SettingsClient}/>
              <Route path="property" component={SettingsProperty}/>
              <Route path="location" component={SettingsLocation}/>
              <Route path="blocked-zipcodes" component={SettingsFilterZip}/>
              <Route path="blocked-zipcodes-area" component={SettingsBulkFilterZip}/>
              <Route path="snooze" component={SettingsSnooze}/>
              <Route path="do_not_disturb" component={SettingsDoNotDisturb}/>
              <Route path="notification" component={SettingsNotification}/>
              <Route path="terms" component={TermsAndConditions}/>
            </Route>
            <Route path="training" component={Training}>
              <IndexRoute component={TrainingHome}/>
              <Route path=":slug" component={TrainingTheme}/>
            </Route>
            <Route path="not-found" component={NotFound}/>
            <Route path="thank-you" component={ThankYou}/>
          </Route>
          <Route path="client_rewards_expired" component={ClientRewardsTermsExpired}/>
          <Route path="login" onEnter={skipLogin} component={Login} />
          <Route path="reset_password" onEnter={skipLogin} component={ResetPassword} />
          <Route path="change_password/:hash" onEnter={skipLogin} component={ChangePassword} />
          <Route path="create_account/:hash" onEnter={skipLogin} component={CreateAccount} />
        </Route>
      </Router>
    )
}
